import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelAutoApplyMutationVariables = Types.Exact<{
  input: Types.CancelGhostwriterAutoApplyInput;
}>;


export type CancelAutoApplyMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', cancelAutoApply: { __typename?: 'CancelGhostwriterAutoApplyPayload', application?: { __typename?: 'GhostwriterApplication', id: string, applicationStatus: Types.GhostwriterApplicationStatus } | null, userErrors: Array<{ __typename?: 'GhostwriterUserError', code?: string | null, field?: Array<string> | null, message: string }> } } };


export const CancelAutoApplyDocument = gql`
    mutation CancelAutoApply($input: CancelGhostwriterAutoApplyInput!) {
  ghostwriter {
    cancelAutoApply(input: $input) {
      application {
        id
        applicationStatus
      }
      userErrors {
        code
        field
        message
      }
    }
  }
}
    `;
export type CancelAutoApplyMutationFn = Apollo.MutationFunction<CancelAutoApplyMutation, CancelAutoApplyMutationVariables>;

/**
 * __useCancelAutoApplyMutation__
 *
 * To run a mutation, you first call `useCancelAutoApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAutoApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAutoApplyMutation, { data, loading, error }] = useCancelAutoApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAutoApplyMutation(baseOptions?: Apollo.MutationHookOptions<CancelAutoApplyMutation, CancelAutoApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAutoApplyMutation, CancelAutoApplyMutationVariables>(CancelAutoApplyDocument, options);
      }
export type CancelAutoApplyMutationHookResult = ReturnType<typeof useCancelAutoApplyMutation>;
export type CancelAutoApplyMutationResult = Apollo.MutationResult<CancelAutoApplyMutation>;
export type CancelAutoApplyMutationOptions = Apollo.BaseMutationOptions<CancelAutoApplyMutation, CancelAutoApplyMutationVariables>;